<div id="main-content" class="{{device}} cf">

    <div id="inner-content" class="cf">

        <div class="left-col">

            <!-- pot -->
            <ng-container  *ngIf="slideshow.quiz">
                <div class="attribution">Advertisement</div>
                <div class="ad primary pot"></div>
            </ng-container>

            <!-- title -->
            <h1 [innerHTML]="slideshow.assignment.articleTitle"></h1>

            <!-- put -->
            <ng-container  *ngIf="!slideshow.quiz">
                <div class="attribution">Advertisement</div>
                <div class="ad primary pot"></div>
            </ng-container>

            <!-- content -->
            <content *ngIf="!slideshow.quiz; else quizContent"></content>

            <!-- quiz content -->
            <ng-template #quizContent>
                <content-quiz></content-quiz>
            </ng-template>

            <!-- pon -->
            <div class="attribution">Advertisement</div>
            <div class="ad primary next"></div>

            <!-- next button -->
            <a id="next-button" class="button">{{slideshow.quiz ? 'Next Quiz' : 'Next Post'}}</a>                

        </div>

        <div class="right-col">
            <div class="attribution">Advertisement</div>
            <div class="ad side"></div>
            <div class="attribution">Advertisement</div>
            <div class="ad side"></div>
        </div>

    </div>